"use client";

import VisitorModal from "@/components/dialog/VisitorModal";
import { Fab } from "@mui/material";
import { useState } from "react";
import { QrCodeScanner } from "@mui/icons-material";
import color from "@/style/theme/Color";
import { KeyedMutator } from "swr";
import { ProfileResponse } from "@/utils/Hooks";
import { ProfileData } from "@/types/shared.types";

type Props = {
  accessToken: string,
  profile?: {
    data: ProfileData | undefined;
    mutate: KeyedMutator<ProfileResponse> | undefined;
  }
}

const QrCodeScanButton = ({ accessToken, profile }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <VisitorModal accessToken={accessToken} open={open} setOpen={setOpen} profile={profile}/>
      <Fab
        color="secondary"
        aria-label="edit"
        onClick={() => setOpen(true)}
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20
        }}
      >
        <QrCodeScanner fontSize="large" sx={{ color: color.light_white }}/>
      </Fab>
    </>
  );
};

export default QrCodeScanButton;
